module.exports = {
    STANDARD_GREEN:"rgba(49,158,78,1)",
    STANDARD_RED:"rgba(204,71,71,1)",
    MOTIONWORKS_BLUE:"#00779F",
    STANDARD_ORANGE:"#DB8851",
    STANDARD_GREY:"rgba(200,200,200,1)",
    DARK_GREY:"#333745",
    LIGHT_BLACK:"#E1E1E1"
};
